'use client';

import { SmartInput } from '@web/ui';

const ROLE_OPTIONS = [
  { value: 'all', label: 'All roles' },
  { value: 'member', label: 'Member' },
  { value: 'lead', label: 'Lead' },
  { value: 'admin', label: 'Admin' },
  { value: 'owner', label: 'Owner' },
] as const;

type WorkspaceMembersRoleSelectProps = {
  value: string;
  onChange: (value: string) => void;
};

export function WorkspaceMembersRoleSelect({
  value,
  onChange,
}: WorkspaceMembersRoleSelectProps) {
  return (
    <div style={{ minWidth: 170 }}>
      <SmartInput
        type="select"
        name="team-role-filter"
        size="small"
        value={value}
        options={ROLE_OPTIONS.map((role) => ({
          value: role.value,
          label: role.label,
        }))}
        onChange={(nextValue) => onChange(String(nextValue))}
      />
    </div>
  );
}
